import React, { Component } from 'react';
import DefaultHeaderDesktop from './DefaultHeaderDesktop';
import DefaultHeaderMobile from './DefaultHeaderMobile';
import { get, post } from './../../utility/apiClient';

/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { showMessageBox } from '../../redux/actions/messageBoxActions';
import { showLoadingScreen, hideLoadingScreen } from '../../redux/actions/loadingScreenActions';
import { resetPromoCodeData } from '../../redux/actions/promoCodeAction';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        responsive: state.responsive,
        PromoCode: state.promoCodeReducer,
        userDetails: state.userDetails
    }
};

const mapDispatchToProps = {
    showLoadingScreen,
    hideLoadingScreen,
    showMessageBox,
    resetPromoCodeData
};

class DefaultHeader extends Component {
    logout() {
        this.props.showLoadingScreen();
        this.promoCodeRollback();

        post("/Login/SessionLogout").then(response => {
            //check response data exist 
            if (response.status == 200) {
                this.promoCodeRollback();
                window.location.href = "/welcome";
            }
        })
    };

    login() {
        this.props.showLoadingScreen();
        window.location.href = "welcome/Login";
    };

    promoCodeRollback() {
        if (!this.props.PromoCode.promoCodeFormat !== null && this.props.PromoCode.promoCodeFormat.length != 0) {

            let formData = {
                promoCodeFormat: this.props.PromoCode.promoCodeFormat,
                promoCodeRollback: true,
                PromoCodeCustomerID: this.props.userDetails.customerID
            };

            post("/Web/RollbackPromoCode", formData).then(response => {
                if (response.status == 200) {
                    this.props.resetPromoCodeData();
                }
            })
        }
    };

    render() {
        return (
            <React.Fragment>
                {
                    this.props.responsive.isTabScreen
                        || this.props.responsive.isMobileLargeScreen
                        || this.props.responsive.isMobileSmallScreen
                        ? <DefaultHeaderMobile logout={this.logout.bind(this)} login={this.login.bind(this)} />
                        : <DefaultHeaderDesktop logout={this.logout.bind(this)} login={this.login.bind(this)} />
                }
            </React.Fragment>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DefaultHeader);
